import { SLA_PAIN_MINUTES, SLA_PAIN_MINUTES_SUCCESS, SLA_PAIN_MINUTES_ERROR, SLA_PAIN_MINUTES_EMPTY } from '../../../actionType';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const SlaPainMinutes = (state = initialState, action) => {
  switch (action.type) {
    case SLA_PAIN_MINUTES:
      state = {
        ...state,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case SLA_PAIN_MINUTES_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case SLA_PAIN_MINUTES_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case SLA_PAIN_MINUTES_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default SlaPainMinutes;
